import { render, staticRenderFns } from "./ClickAndBuyElement.vue?vue&type=template&id=1318d61c&scoped=true"
import script from "./ClickAndBuyElement.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyElement.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyElement.vue?vue&type=style&index=0&id=1318d61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318d61c",
  null
  
)

export default component.exports